/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JsonPatchOperation } from '../../models/json-patch-operation';
import { PurchaseOrder } from '../../models/purchase-order';

export interface PatchPurchaseOrder$Params {
  uuid: string;
      body: Array<JsonPatchOperation>
}

export function patchPurchaseOrder(http: HttpClient, rootUrl: string, params: PatchPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
  const rb = new RequestBuilder(rootUrl, patchPurchaseOrder.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json-patch+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseOrder>;
    })
  );
}

patchPurchaseOrder.PATH = '/purchase-orders/{uuid}';
